import { IS_APP, IS_TESTING } from "@/__main__/constants.mjs";
import eventBus from "@/app/app-event-bus.mjs";
import { EVENT_TRACK_AD_VIDEO_VIEW } from "@/feature-ads/constants/events.mjs";
import { getPageTargetingMap } from "@/feature-ads/display-server-google.mjs";
import adsRefs from "@/feature-ads/refs.mjs";
import { devLog } from "@/util/dev.mjs";
import globals from "@/util/global-whitelist.mjs";

const SCRIPT_URL = "https://player.ex.co/player";
const EXCO_IDS = {
  profile: "fff2a1b4-91f7-47b3-8471-3c8fabcc1dc8",
  outstream: "a7f387b6-a04c-4beb-993d-e93b6979a42b",
};
const FALLBACK_SCRIPT_ID = "0cd1e923-ae87-4bd1-86c6-d055f2cc7b60";
let isInit = false,
  isInitializePlacement = false;

export const VIDEO_EXCO = {
  aspectRatio: "16 / 9",
  init: () => {
    if (IS_TESTING || isInit) return;
    isInit = true;
    // @ts-ignore
    // eslint-disable-next-line no-restricted-properties
    globals.addEventListener("message", async (event) => {
      if (event.data?.type === "exco-event") {
        const { name } = event.data;
        if (name === "ad-impression") {
          let ram = 0;
          if (IS_APP) {
            const heapStats =
              await globals.__BLITZ__.process.getHeapStatistics();
            ram = heapStats.usedHeapSize * 1024;
            // @ts-ignore
          } else if (globals.performance.memory) {
            // @ts-ignore
            ram = globals.performance.memory.usedJSHeapSize;
          }
          eventBus.emit(EVENT_TRACK_AD_VIDEO_VIEW, {
            provider: "exco",
            ram,
          });
          devLog("[Exco] AdImpression", event.data);
        }
      }
    });
  },
  initializePlacement(element: HTMLElement) {
    const placement = globals.document.createElement("div");
    placement.style.position = "relative";
    const scriptId = adsRefs.useOutstream
      ? EXCO_IDS.outstream
      : EXCO_IDS[element.dataset.pageMacro] || FALLBACK_SCRIPT_ID;

    placement.id = scriptId;
    if (IS_TESTING || isInitializePlacement) return placement;
    isInitializePlacement = true;
    adsRefs
      .googleCmd(() => {})
      .then(() => {
        const pageTargeting = getPageTargetingMap();
        const config = {
          reporting: {
            utm_source: pageTargeting.game,
            utm_medium: pageTargeting.route,
            // Pass the value through the UTM_term=0 parameter for Web and UTM_term=1 for App
            utm_term: IS_APP ? "1" : "0",
          },
        };
        placement.setAttribute("data-exs-config", JSON.stringify(config));
      });

    const scriptEl = globals.document.createElement("script");
    scriptEl.className = "exco-player";
    scriptEl.src = `${SCRIPT_URL}/${scriptId}`;

    placement.appendChild(scriptEl);

    return placement;
  },
  onPlacementAppend(_parent: HTMLElement, _placement: HTMLElement) {},
  onDestroy(_activeRef) {}, // noop
  vendorCloseButton: true,
  vendorIntersectionFloat: !IS_TESTING,
  vendorNavFloat: false,
  onNavFloat: () => {},
};
